(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[60],{

/***/ 4565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ Common_Button; },
  "D": function() { return /* reexport */ Common_Title; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/Common/Button.tsx


var _excluded = ["text", "className", "icon"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Button = function Button(_ref) {
  var text = _ref.text,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      icon = _ref.icon,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("button", _objectSpread(_objectSpread({
    className: "text-white bg-lightBlue hover:bg-lightBlue-700 btnMedium flex justify-center items-center gap-2 ".concat(className)
  }, rest), {}, {
    children: [icon && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
      src: icon,
      width: 20,
      height: 20
    }), text]
  }));
};

/* harmony default export */ var Common_Button = (Button);
;// CONCATENATED MODULE: ./components/Common/Title.tsx


var Title = function Title(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'center' : _ref$align;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
    className: "inline-block gradient-head-large !text-h5Bold text-center !leading-10 !md:text-h2Bold !md:leading-[3.5rem] text-".concat(align, " ").concat(className),
    children: children
  });
};

/* harmony default export */ var Common_Title = (Title);
;// CONCATENATED MODULE: ./components/Common/index.ts



/***/ }),

/***/ 2689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* reexport */ Footer_Footer; }
});

// EXTERNAL MODULE: ./components/Common/index.ts + 2 modules
var Common = __webpack_require__(4565);
// EXTERNAL MODULE: ./components/Contexts/LocaleContext.tsx
var LocaleContext = __webpack_require__(5314);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(5627);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/Footer/FooterOldDesignStyle.tsx




var FooterOldDesignStyle = function FooterOldDesignStyle() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)((style_default()), {
    id: "475840717",
    children: [".btnMedium{padding-left:16px;padding-right:16px;padding-top:10px;padding-bottom:10px;border-radius:6px;font-family:\"BaiJamjuree\",\"Helvetica\",sans-serif;font-size:16px;line-height:normal;}", ".text-p2Medium{font-family:\"BaiJamjuree\",\"Helvetica\",sans-serif;font-size:16px;line-height:24px;font-weight:500;}", ".text-p3Medium{font-family:\"BaiJamjuree\",\"Helvetica\",sans-serif;font-size:14px;line-height:20px;font-weight:500;}", ".text-p3Regular{font-family:\"BaiJamjuree\",\"Helvetica\",sans-serif;font-size:14px;line-height:20px;font-weight:400;}", ".text-p4Regular{font-family:\"BaiJamjuree\",\"Helvetica\",sans-serif;font-size:12px;line-height:20px;font-weight:400;}", ".text-h6Medium{font-family:\"BaiJamjuree\",\"Helvetica\",sans-serif;font-size:20px;line-height:28px;font-weight:500;}", ".px-4{padding-left:16px;padding-right:16px;}", ".px-10{padding-left:40px;padding-right:40px;}", ".px-16{padding-left:64px;padding-right:64px;}", ".py-2{padding-top:8px;padding-bottom:8px;}", ".py-4{padding-top:16px;padding-bottom:16px;}", ".py-5{padding-top:20px;padding-bottom:20px;}", ".py-7{padding-top:28px;padding-bottom:28px;}", ".mr-3{margin-right:12px;}", ".mt-4{margin-top:16px;}", ".mb-7{margin-bottom:28px;}", ".my-7{margin-top:28px;margin-bottom:28px;}", ".gap-2{gap:8px;}", ".gap-3{gap:12px;}", ".gap-5{gap:20px;}", ".rounded-md{border-radius:6px;}", "@media (min-width:768px){.md\\:px-4{padding-left:16px !important;padding-right:16px !important;}.md\\:text-p2Medium{font-family:\"BaiJamjuree\",\"Helvetica\",sans-serif;font-size:16px !important;line-height:24px !important;font-weight:500 !important;}}", "@media (min-width:1024px){.lg\\:px-16{padding-left:64px !important;padding-right:64px !important;}}"]
  });
};

/* harmony default export */ var Footer_FooterOldDesignStyle = (FooterOldDesignStyle);
;// CONCATENATED MODULE: ./components/Footer/Footer.tsx











var Footer = function Footer(_ref) {
  var _ref$showLetsTalk = _ref.showLetsTalk,
      showLetsTalk = _ref$showLetsTalk === void 0 ? false : _ref$showLetsTalk,
      _ref$forOldDesign = _ref.forOldDesign,
      forOldDesign = _ref$forOldDesign === void 0 ? false : _ref$forOldDesign;
  var router = (0,next_router.useRouter)();

  var _useLocale = (0,LocaleContext/* useLocale */.b)(),
      lang = _useLocale.lang;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("footer", {
      id: "footer",
      className: "w-screen bg-black",
      children: [showLetsTalk && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "Container px-4 py-7 flex flex-col justify-center items-center bg-darkBlue text-white",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            alt: "mini-logo-codium",
            src: "/images/minilogocodium.svg",
            width: 40,
            height: 40
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
          className: "text-h6Medium",
          children: "LET'S TALK"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: " text-p3Regular",
          children: "Tell us more about your project"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mt-4",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Common/* Button */.z, {
            id: "contact-us",
            text: lang === 'en' ? 'CONTACT US' : 'ติดต่อเรา',
            className: "font-medium",
            onClick: function onClick() {
              return router.push('/contact-us');
            }
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-screen bg-black",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "Container flex flex-col md:flex-row md:justify-between",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col text-white items-start my-7",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
              className: " text-p3Medium md:text-p2Medium mb-7",
              children: lang === 'en' ? 'CONTACT US' : 'ติดต่อเรา'
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "flex flex-col gap-5",
              children: contacts.map(function (contact) {
                var _contact$textTH;

                return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: contact.link,
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                    className: "flex gap-3 items-center cursor-pointer hover:text-neutral-400",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "w-[20px] h-[20px]",
                      children: contact.icon && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                        alt: contact.alt,
                        src: contact.icon,
                        width: 20,
                        height: 20
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "text-p3Regular hover:underline",
                      children: lang === 'en' ? contact.text : (_contact$textTH = contact === null || contact === void 0 ? void 0 : contact.textTH) !== null && _contact$textTH !== void 0 ? _contact$textTH : contact.text
                    })]
                  })
                }, contact.id);
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col items-start md:w-[278px] lg:w-[448px]",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "md:hidden w-full flex justify-around items-center rounded-md my-[10px] py-2 px-10 bg-[#28272C]",
              children: socials.map(function (social) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: social.link,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    className: "flex justify-center items-center cursor-pointer",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                      alt: social.alt,
                      src: social.icon,
                      width: 20,
                      height: 20
                    })
                  })
                }, social.id);
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex flex-col mt-7 mb-4 items-start text-white text-p4Regular",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "text-p4Regular",
                children: lang === 'en' ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                  children: ["SIAM@SIAM Hotel Building ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "7th Floor 865 Rama 1 Road ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Wang Mai, Patumwan ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Bangkok 10330 ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Thailand"]
                }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                  children: ["\u0E42\u0E23\u0E07\u0E41\u0E23\u0E21 SIAM@SIAM ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u0E0A\u0E31\u0E49\u0E19 7, 865 \u0E16\u0E19\u0E19 \u0E1E\u0E23\u0E30\u0E23\u0E32\u0E21 1 ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u0E41\u0E02\u0E27\u0E07 \u0E27\u0E31\u0E07\u0E43\u0E2B\u0E21\u0E48, \u0E40\u0E02\u0E15 \u0E1B\u0E17\u0E38\u0E21\u0E27\u0E31\u0E19 ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E\u0E21\u0E2B\u0E32\u0E19\u0E04\u0E23 10330"]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "text-p4Regular",
                children: lang === 'en' ? 'Office Hours: Monday - Friday (09.00 - 18.00)' : 'เวลาทำการ: จันทร์ - ศุกร์ (09.00 - 18.00)'
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "hidden md:flex w-full justify-around items-center rounded-md my-[10px] py-2 md:px-4 lg:px-16 bg-[#28272C]",
              children: socials.map(function (social) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: social.link,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    className: "flex justify-center items-center cursor-pointer hover:scale-150 ease-in-out duration-200",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                      alt: social.alt,
                      src: social.icon,
                      width: 20,
                      height: 20
                    })
                  })
                }, social.id);
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "flex flex-col lg:flex-row mt-4 mb-4 gap-2 lg:gap-4 items-start text-neutral-500 text-p4Regular",
              children: pdpas.map(function (pdpa) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: pdpa.link,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    className: "text-p4Regular cursor-pointer hover:text-white font-bold",
                    children: pdpa[lang]
                  })
                }, pdpa.link);
              })
            })]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-full bg-black flex justify-center items-center py-2",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: " text-p4Regular text-white",
          children: "Copyright \xA9 2025 by CODIUM all right reserved"
        })
      })]
    }), forOldDesign && /*#__PURE__*/(0,jsx_runtime.jsx)(Footer_FooterOldDesignStyle, {})]
  });
};

/* harmony default export */ var Footer_Footer = (Footer);
var contacts = [{
  id: 1,
  alt: 'phone',
  icon: '/icons/iphone.svg',
  text: '02-0982099, Mon - Fri (09.00-18.00)',
  textTH: '02-0982099, จันทร์ - ศุกร์ (09.00-18.00)',
  link: 'tel:02-0982099'
}, {
  id: 3,
  alt: 'mail',
  icon: '/icons/mail.svg',
  text: 'sales@codium.co',
  textTH: 'sales@codium.co',
  link: 'mailto:sales@codium.co'
}, {
  id: 5,
  alt: 'line',
  icon: '/icons/line.svg',
  text: '@codium',
  link: 'https://line.me/ti/p/%40codium'
}];
var socials = [{
  id: 1,
  alt: 'facebook',
  icon: '/icons/facebook_circle.svg',
  link: 'https://www.facebook.com/codium/'
}, {
  id: 2,
  alt: 'youtube',
  icon: '/icons/youtube_circle.svg',
  link: 'https://www.youtube.com/channel/UCQ7PU-eA4lmdWkN86lYsJUw/videos'
}, {
  id: 3,
  alt: 'linkedin',
  icon: '/icons/linkedin_circle.svg',
  link: 'https://th.linkedin.com/company/c0d1um'
}, {
  id: 4,
  alt: 'medium',
  icon: '/icons/medium.svg',
  link: 'https://medium.com/c0d1um'
}];
var pdpas = [{
  link: '/privacy-policy',
  en: 'Privacy Policy',
  th: 'นโยบายความเป็นส่วนตัว'
}, {
  link: '/cookie-policy',
  en: 'Cookie Settings',
  th: 'การตั้งค่าคุกกี้'
}, {
  link: '/data-subject-right-request',
  en: 'Data Subject Rights Request',
  th: 'คำขอใช้สิทธิของเจ้าของข้อมูลส่วนบุคคล'
}];
;// CONCATENATED MODULE: ./components/Footer/index.ts


/***/ }),

/***/ 9954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rp": function() { return /* reexport */ Icons_Bookmark; },
  "a7": function() { return /* reexport */ Icons_Briefcase; },
  "_M": function() { return /* reexport */ Icons_ChevronDown; },
  "X1": function() { return /* reexport */ Icons_Cross; },
  "BB": function() { return /* reexport */ Icons_Document; },
  "IG": function() { return /* reexport */ Icons_Fingerprint; },
  "pr": function() { return /* reexport */ Icons_Hamburger; }
});

// UNUSED EXPORTS: Codium, Coins

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/Icons/Document.tsx



var Document = function Document(_ref) {
  var _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? '#29ADCE' : _ref$stroke;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M6.19053 9.99992H10.9524M6.19053 11.9047H12.8572M6.19053 13.8094H9.04767M15.7143 14.7618V8.09516L10.9524 3.33325H6.19053C5.68535 3.33325 5.20087 3.53393 4.84366 3.89114C4.48645 4.24836 4.28577 4.73284 4.28577 5.23801V14.7618C4.28577 15.267 4.48645 15.7515 4.84366 16.1087C5.20087 16.4659 5.68535 16.6666 6.19053 16.6666H13.8096C14.3148 16.6666 14.7992 16.4659 15.1564 16.1087C15.5137 15.7515 15.7143 15.267 15.7143 14.7618V14.7618Z",
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M10.9524 3.33325V6.19039C10.9524 6.69557 11.1531 7.18005 11.5103 7.53726C11.8675 7.89448 12.352 8.09516 12.8572 8.09516H15.7143",
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};

/* harmony default export */ var Icons_Document = (Document);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/Icons/Fingerprint.tsx




var Fingerprint = function Fingerprint(_ref) {
  var _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? '#29ADCE' : _ref$stroke;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M15.7143 11.9332C15.7143 14.5475 14.5191 17.619 10.0001 17.619C9.35368 17.6252 8.70905 17.5509 8.081 17.398M6.40386 16.6542C4.79434 15.5399 4.28577 13.638 4.28577 11.9332V8.09515C4.28577 6.60372 4.90958 5.25706 5.90958 4.30372M7.50196 3.0142C8.26855 2.59739 9.12748 2.37963 10.0001 2.38086C11.6696 2.38086 13.3267 3.06944 14.2858 4.28563M15.4343 5.44753C15.6153 5.97991 15.7143 6.54944 15.7143 7.14277V9.99991",
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M10.0001 15.7142C8.73055 15.079 8.09531 14.1361 8.09531 12.8856V8.09517C8.09531 7.58999 8.29599 7.10551 8.65321 6.7483C9.01042 6.39109 9.4949 6.19041 10.0001 6.19041C10.5052 6.19041 10.9897 6.39109 11.3469 6.7483C11.7042 7.10551 11.9048 7.58999 11.9048 8.09517V11.9333C11.9048 12.5685 12.222 12.8856 12.8572 12.8856C13.4925 12.8856 13.8096 12.5685 13.8096 11.9333V7.68184C13.8096 7.24748 13.7106 6.81884 13.5201 6.4285C12.8229 4.99993 11.6496 4.28564 10.0001 4.28564C8.35055 4.28564 7.17722 4.99993 6.48008 6.4285C6.28955 6.81884 6.19054 7.24748 6.19055 7.68184V12.8571C6.19055 13.8095 6.3496 14.4447 6.66674 14.7618",
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M10 8.09521V11.9333C10 13.819 10.9524 14.7619 12.8571 14.7619",
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};

/* harmony default export */ var Icons_Fingerprint = (Fingerprint);
;// CONCATENATED MODULE: ./components/Icons/Bookmark.tsx



var Bookmark = function Bookmark(_ref) {
  var _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? '#29ADCE' : _ref$stroke;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.19053 3.33325H13.8096C14.3148 3.33325 14.7992 3.53393 15.1564 3.89114C15.5137 4.24836 15.7143 4.73284 15.7143 5.23801V14.7618C15.7143 15.267 15.5137 15.7515 15.1564 16.1087C14.7992 16.4659 14.3148 16.6666 13.8096 16.6666H6.19053C5.68535 16.6666 5.20087 16.4659 4.84366 16.1087C4.48645 15.7515 4.28577 15.267 4.28577 14.7618V5.23801C4.28577 4.73284 4.48645 4.24836 4.84366 3.89114C5.20087 3.53393 5.68535 3.33325 6.19053 3.33325V3.33325Z",
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.14294 3.33325H10.9525V8.10659L9.04771 6.19039L7.14294 8.10659V3.33325Z",
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};

/* harmony default export */ var Icons_Bookmark = (Bookmark);
;// CONCATENATED MODULE: ./components/Icons/Briefcase.tsx



var Briefcase = function Briefcase(_ref) {
  var _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? '#29ADCE' : _ref$stroke;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M5.23814 7.14279H14.7619C15.2671 7.14279 15.7516 7.34347 16.1088 7.70068C16.466 8.05789 16.6667 8.54238 16.6667 9.04755V13.8095C16.6667 14.3146 16.466 14.7991 16.1088 15.1563C15.7516 15.5135 15.2671 15.7142 14.7619 15.7142H5.23814C4.73296 15.7142 4.24848 15.5135 3.89127 15.1563C3.53405 14.7991 3.33337 14.3146 3.33337 13.8095V9.04755C3.33337 8.54238 3.53405 8.05789 3.89127 7.70068C4.24848 7.34347 4.73296 7.14279 5.23814 7.14279V7.14279ZM9.04766 4.28564H10.9524C11.4576 4.28564 11.9421 4.48632 12.2993 4.84354C12.6565 5.20075 12.8572 5.68523 12.8572 6.19041V7.14279H7.1429V6.19041C7.1429 5.68523 7.34358 5.20075 7.70079 4.84354C8.058 4.48632 8.54249 4.28564 9.04766 4.28564Z",
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};

/* harmony default export */ var Icons_Briefcase = (Briefcase);
;// CONCATENATED MODULE: ./components/Icons/Coins.tsx



var Coins = function Coins(_ref) {
  var _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? '#29ADCE' : _ref$stroke;
  return /*#__PURE__*/_jsxs("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M17.6191 10.9524V13.8095C17.6191 15.0476 14.6343 16.6667 10.9524 16.6667C7.27053 16.6667 4.28577 15.0476 4.28577 13.8095V11.4286",
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M4.56567 11.6752C5.38948 12.7686 7.9371 13.7943 10.9523 13.7943C14.6342 13.7943 17.619 12.2648 17.619 10.9505C17.619 10.2124 16.679 9.4038 15.2038 8.83618",
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.7619 6.19055V9.04769C14.7619 10.2858 11.7772 11.9048 8.09526 11.9048C4.41335 11.9048 1.42859 10.2858 1.42859 9.04769V6.19055",
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.09526 9.03242C11.7772 9.03242 14.7619 7.5029 14.7619 6.18861C14.7619 4.87337 11.7772 3.33337 8.09526 3.33337C4.41335 3.33337 1.42859 4.87337 1.42859 6.18861C1.42859 7.5029 4.41335 9.03242 8.09526 9.03242Z",
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};

/* harmony default export */ var Icons_Coins = ((/* unused pure expression or super */ null && (Coins)));
;// CONCATENATED MODULE: ./components/Icons/Codium.tsx



var Codium = function Codium(_ref) {
  var _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'dark' : _ref$mode;
  return /*#__PURE__*/_jsxs("svg", {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M20.3805 25.0723H11.8224C11.129 25.0723 10.4884 24.7059 10.1408 24.1127L5.96416 16.9595C5.61831 16.3663 5.61831 15.6335 5.96416 15.0404L10.1408 7.88716C10.4867 7.29397 11.129 6.92759 11.8224 6.92759H20.3787C20.5675 6.92759 20.7422 6.82814 20.8375 6.66588L23.0785 2.82759C23.2814 2.47865 23.0273 2.04248 22.6197 2.04248H8.97094C8.27747 2.04248 7.63694 2.40886 7.28933 3.00205L0.259388 15.0404C-0.0864626 15.6335 -0.0864626 16.3663 0.259388 16.9595L7.28933 28.9978C7.63518 29.591 8.27747 29.9574 8.97094 29.9574H22.6232C23.0308 29.9574 23.2849 29.5212 23.082 29.1723L20.841 25.334C20.7457 25.1717 20.571 25.0723 20.3822 25.0723H20.3805Z",
      fill: mode === 'dark' ? '#0D375B' : '#FFFFFF'
    }), /*#__PURE__*/_jsx("path", {
      d: "M23.996 3.36668L21.7551 7.20498C21.6598 7.36724 21.6598 7.56613 21.7551 7.72838L26.0341 15.056C26.3799 15.6492 26.3799 16.382 26.0341 16.9752L21.7551 24.3029C21.6598 24.4651 21.6598 24.664 21.7551 24.8263L23.996 28.6646C24.199 29.0135 24.7089 29.0135 24.9136 28.6646L31.7388 16.9752C32.0847 16.382 32.0847 15.6492 31.7388 15.056L24.9136 3.36668C24.7107 3.01775 24.2007 3.01775 23.996 3.36668Z",
      fill: "#E74342"
    }), /*#__PURE__*/_jsx("path", {
      d: "M16.4065 7.97412H11.8222C11.5063 7.97412 11.2152 8.13987 11.0581 8.41029L6.88146 15.5635C6.72441 15.8339 6.72441 16.1654 6.88146 16.4358L11.0581 23.589C11.2152 23.8594 11.5063 24.0252 11.8222 24.0252H16.4065C16.6782 24.0252 16.8476 23.7338 16.7117 23.5018L12.5862 16.4358C12.4292 16.1654 12.4292 15.8339 12.5862 15.5635L16.7117 8.49753C16.8476 8.26548 16.6782 7.97412 16.4065 7.97412Z",
      fill: "#35ADCE"
    })]
  });
};

/* harmony default export */ var Icons_Codium = ((/* unused pure expression or super */ null && (Codium)));
;// CONCATENATED MODULE: ./components/Icons/Hamburger.tsx




var Hamburger = function Hamburger() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M7.00305 10H25.0001",
      stroke: "#404040",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M7 15.999H24.9925",
      stroke: "#404040",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M7.00305 21.998H24.9926",
      stroke: "#404040",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};

/* harmony default export */ var Icons_Hamburger = (Hamburger);
;// CONCATENATED MODULE: ./components/Icons/Cross.tsx




var Cross = function Cross(_ref) {
  var stroke = _ref.stroke;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.7621 14.7621L5.23828 5.23828L14.7621 14.7621Z",
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M14.7621 5.23828L5.23828 14.7621",
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};

/* harmony default export */ var Icons_Cross = (Cross);
;// CONCATENATED MODULE: ./components/Icons/ChevronDown.tsx



var ChevronDown = function ChevronDown(_ref) {
  var _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 'black' : _ref$stroke;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M13.8095 8.09521L9.99995 11.9047L6.19043 8.09521",
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};

/* harmony default export */ var Icons_ChevronDown = (ChevronDown);
;// CONCATENATED MODULE: ./components/Icons/index.ts










/***/ }),

/***/ 7430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* reexport */ Navbar_Navbar; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./components/Common/index.ts + 2 modules
var Common = __webpack_require__(4565);
// EXTERNAL MODULE: ./components/Icons/index.ts + 9 modules
var Icons = __webpack_require__(9954);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/animation/hooks/use-animation.mjs + 1 modules
var use_animation = __webpack_require__(2233);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 4 modules
var AnimatePresence = __webpack_require__(5820);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 109 modules
var motion = __webpack_require__(3253);
// EXTERNAL MODULE: ./components/Contexts/LocaleContext.tsx
var LocaleContext = __webpack_require__(5314);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/Contexts/TailwindBreakpointContext.tsx + 4 modules
var TailwindBreakpointContext = __webpack_require__(9806);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/Sidebar/SidebarItem.tsx










var SidebarItem = function SidebarItem(_ref) {
  var icon = _ref.icon,
      label = _ref.label,
      linkTo = _ref.linkTo,
      closeSidebar = _ref.closeSidebar,
      expand = _ref.expand,
      _ref$expandSubItem = _ref.expandSubItem,
      expandSubItem = _ref$expandSubItem === void 0 ? function (l) {} : _ref$expandSubItem,
      _ref$subItems = _ref.subItems,
      subItems = _ref$subItems === void 0 ? [] : _ref$subItems;

  var _useState = (0,react.useState)(false),
      hasSubItem = _useState[0],
      setHasSubItem = _useState[1];

  var animateChevron = (0,use_animation/* useAnimation */._)();

  var _useLocale = (0,LocaleContext/* useLocale */.b)(),
      lang = _useLocale.lang;

  var _useTailwindBreakpoin = (0,TailwindBreakpointContext/* useTailwindBreakpoint */._)(),
      screen = _useTailwindBreakpoin.screen;

  (0,react.useEffect)(function () {
    setHasSubItem(subItems.length > 0);
  }, [subItems]);
  (0,react.useEffect)(function () {
    animateChevron.start({
      rotate: expand ? 180 : 0,
      transition: {
        duration: 0.2
      }
    });
  }, [expand]);

  var itemElement = /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "px-4 md:px-6 py-5 text-neutral-700 cursor-pointer flex justify-between",
    onClick: function onClick() {
      return expandSubItem(label);
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex items-center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-[20px] h-[20px] mr-3",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: icon,
          width: 20,
          height: 20,
          layout: "fixed"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex flex-col",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
          className: "text-p2Medium",
          children: label
        })
      })]
    }), hasSubItem && /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
      className: "h-fit w-fit",
      animate: animateChevron,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* ChevronDown */._M, {
        stroke: "rgb(64,64,64)"
      })
    })]
  });

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "flex flex-col",
    children: [linkTo ? /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: linkTo,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        onClick: closeSidebar,
        children: itemElement
      })
    }) : itemElement, /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
      children: expand && hasSubItem && /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.ul */.E.ul, {
        className: "flex-grow md:pl-14 md:pr-6 md:space-y-4",
        initial: {
          height: 0
        },
        animate: {
          height: 'fit-content'
        },
        exit: {
          height: 0
        },
        transition: {
          duration: 0.3,
          ease: 'easeInOut'
        },
        children: subItems.map(function (item, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.li */.E.li, {
            initial: "initial",
            animate: "animate",
            exit: "exit",
            custom: i,
            variants: {
              initial: {
                opacity: 0,
                x: '10%'
              },
              animate: function animate(i) {
                return {
                  opacity: 1,
                  x: 0,
                  transition: {
                    delay: 0.25 + i * 0.08,
                    duration: 0.15
                  }
                };
              },
              exit: {
                opacity: 0,
                x: '10%',
                transition: {
                  duration: 0.15
                }
              }
            },
            children: screen === 'md' ?
            /*#__PURE__*/
            // for tablet
            (0,jsx_runtime.jsx)((link_default()), {
              href: item.linkTo,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                onClick: closeSidebar,
                className: "flex border-lightBlue-50 space-x-[16px] border-2 w-full px-[20px] py-[16px] rounded-[6px] hover:bg-lightBlue-50",
                children: [(item === null || item === void 0 ? void 0 : item.icon) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                    src: item.icon,
                    width: 24,
                    height: 24
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flex flex-col justify-start",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                    className: " text-p2Semibold text-neutral-700",
                    children: item.label
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: " text-p3Regular text-neutral-500",
                    children: lang === 'en' ? item.subLabel : item.subLabelTH
                  })]
                })]
              })
            }, item.label) :
            /*#__PURE__*/
            // for mobile
            (0,jsx_runtime.jsx)((link_default()), {
              href: item.linkTo,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                onClick: closeSidebar,
                className: "px-4 md:px-6 py-4 text-neutral-700 flex cursor-pointer",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "w-[20px] h-[20px] mr-3"
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flex flex-col",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                    className: "text-p3Semibold",
                    children: item.label
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "text-p3Regular text-neutral-500",
                    children: lang === 'en' ? item.subLabel : item.subLabelTH
                  })]
                })]
              })
            })
          }, item.label);
        })
      })
    })]
  });
};

/* harmony default export */ var Sidebar_SidebarItem = (SidebarItem);
;// CONCATENATED MODULE: ./components/Sidebar/Sidebar.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var Sidebar = function Sidebar(_ref) {
  var items = _ref.items,
      closeSidebar = _ref.closeSidebar,
      clickLogo = _ref.clickLogo,
      expandSubItem = _ref.expandSubItem;

  var _useLocale = (0,LocaleContext/* useLocale */.b)(),
      lang = _useLocale.lang,
      setLang = _useLocale.setLang;

  var changeLang = function changeLang(lang) {
    setLang(lang);
    closeSidebar();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "w-screen h-screen flex flex-col select-none bg-white shadow overflow-y-scroll overflow-x-hidden scrollbar-none",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "w-full px-4 md:px-6 py-2 flex justify-between items-center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          onClick: clickLogo,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "flex justify-center items-center",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: "/images/navbar/codiumDarkFull.png",
              width: 140,
              height: 40,
              priority: true
            })
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        className: "cursor-pointer",
        onClick: closeSidebar,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* Cross */.X1, {
          stroke: "rgb(64,64,64)"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      children: items.map(function (item) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Sidebar_SidebarItem, _objectSpread(_objectSpread({}, item), {}, {
            closeSidebar: closeSidebar,
            expandSubItem: expandSubItem
          }))
        }, item.label);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mt-12 mb-4 flex justify-center items-center text-neutral-700",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        className: "flex items-center cursor-pointer px-2 opacity-50 ".concat(lang === 'th' && 'opacity-100'),
        onClick: function onClick() {
          return changeLang('th');
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
          className: "text-p2Medium",
          children: "TH"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-0.5 h-3.5 bg-neutral-300"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        className: "flex items-center cursor-pointer px-2 opacity-50 ".concat(lang === 'en' && 'opacity-100'),
        onClick: function onClick() {
          return changeLang('en');
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
          className: "text-p2Medium",
          children: "EN"
        })
      })]
    })]
  });
};

/* harmony default export */ var Sidebar_Sidebar = (Sidebar);
;// CONCATENATED MODULE: ./components/Sidebar/index.ts

// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(6261);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(5627);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
;// CONCATENATED MODULE: ./components/Navbar/NavbarOldDesignStyle.tsx


/**
 * For old design It's hard to use REM unit, so I change tailwind class unit to be PX
 */



var NavbarOldDesignStyle = function NavbarOldDesignStyle() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)((style_default()), {
    id: "3177047973",
    children: ["li{list-style-type:none;}", ".btnMedium{padding-left:16px;padding-right:16px;padding-top:10px;padding-bottom:10px;border-radius:6px;font-family:\"BaiJamjuree\",\"Helvetica\",sans-serif;font-size:16px;line-height:normal;}", ".text-p2Medium{font-family:\"BaiJamjuree\",\"Helvetica\",sans-serif;font-size:16px;line-height:24px;font-weight:500;}", ".text-p3Semibold{font-family:\"BaiJamjuree\",\"Helvetica\",sans-serif;font-size:14px;line-height:20px;font-weight:600;}", ".text-p3Regular{font-family:\"BaiJamjuree\",\"Helvetica\",sans-serif;font-size:14px;line-height:20px;font-weight:400;}", ".text-p2Semibold{font-family:\"BaiJamjuree\",\"Helvetica\",sans-serif;font-size:16px;line-height:24px;font-weight:600;}", ".p-5{padding:20px;}", ".px-4{padding-left:16px;padding-right:16px;}", ".py-2{padding-top:8px;padding-bottom:8px;}", ".py-4{padding-top:16px;padding-bottom:16px;}", ".py-5{padding-top:20px;padding-bottom:20px;}", ".px-3{padding-left:12px;padding-right:12px;}", ".px-6{padding-left:24px;padding-right:24px;}", ".mr-1{margin-right:4px;}", ".mr-3{margin-right:12px;}", ".space-x-3>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0 !important;margin-right:calc(12px * var(--tw-space-x-reverse)) !important;margin-left:calc(12px * (1 - var(--tw-space-x-reverse))) !important;}", "@media (min-width:768px){.md\\:px-6{padding-left:24px !important;padding-right:24px !important;}.md\\:space-x-4>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0 !important;margin-right:calc(16px * var(--tw-space-x-reverse)) !important;margin-left:calc(16px * (1 - var(--tw-space-x-reverse))) !important;}.md\\:pr-6{padding-right:24px !important;}.md\\:space-y-4>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-top:calc(16px * (1 - var(--tw-space-y-reverse)));margin-bottom:calc(16px * var(--tw-space-y-reverse));}}", "@media (min-width:1440px){.xxl\\:text-p2Medium{font-family:\"BaiJamjuree\",\"Helvetica\",sans-serif !important;font-size:16px !important;line-height:24px !important;font-weight:500 !important;}.xxl\\:mr-3{margin-right:12px !important;}.xxl\\:px-5{padding-left:20px !important;padding-right:20px !important;}}"]
  });
};

/* harmony default export */ var Navbar_NavbarOldDesignStyle = (NavbarOldDesignStyle);
;// CONCATENATED MODULE: ./components/Navbar/NavbarDesktopItem.tsx







var NavbarDesktopItem = function NavbarDesktopItem(_ref) {
  var icon = _ref.icon,
      inactiveIcon = _ref.inactiveIcon,
      label = _ref.label,
      expand = _ref.expand,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$expandSubItem = _ref.expandSubItem,
      expandSubItem = _ref$expandSubItem === void 0 ? function (l) {} : _ref$expandSubItem,
      _ref$subItems = _ref.subItems,
      subItems = _ref$subItems === void 0 ? [] : _ref$subItems;
  var animateChevron = (0,use_animation/* useAnimation */._)();
  (0,react.useEffect)(function () {
    animateChevron.start({
      rotate: expand ? 180 : 0,
      transition: {
        duration: 0.2
      }
    });
  }, [expand]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "relative h-full w-fit flex justify-center items-center py-5 px-3 xxl:px-5 cursor-pointer hover:bg-lightBlue-50",
    onClick: function onClick() {
      return expandSubItem(label);
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "w-[20px] h-[20px] mr-1 xxl:mr-3 menu-icon",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: active || expand ? icon : inactiveIcon,
        width: 20,
        height: 20,
        layout: "fixed"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      className: " text-p3Medium xxl:text-p2Medium text-neutral-700 mr-1 xxl:mr-3",
      children: label
    }), (subItems === null || subItems === void 0 ? void 0 : subItems.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
      className: "h-fit w-fit",
      animate: animateChevron,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* ChevronDown */._M, {
        stroke: "rgb(64,64,64)"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
      children: (active || expand) && /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
        className: "absolute inset-x-0 bottom-0 h-[4px] bg-lightBlue",
        initial: {
          width: 0
        },
        animate: {
          width: '100%'
        },
        exit: {
          width: 0
        },
        transition: {
          duration: 0.2,
          ease: 'easeInOut'
        }
      })
    })]
  });
};

/* harmony default export */ var Navbar_NavbarDesktopItem = (NavbarDesktopItem);
// EXTERNAL MODULE: ./components/Navbar/Navbar.module.scss
var Navbar_module = __webpack_require__(3161);
var Navbar_module_default = /*#__PURE__*/__webpack_require__.n(Navbar_module);
;// CONCATENATED MODULE: ./components/Navbar/NavbarDesktopSubItem.tsx








var NavbarDesktopSubItem = function NavbarDesktopSubItem(_ref) {
  var label = _ref.label,
      _ref$subItems = _ref.subItems,
      subItems = _ref$subItems === void 0 ? [] : _ref$subItems;

  var _useLocale = (0,LocaleContext/* useLocale */.b)(),
      lang = _useLocale.lang;

  var _useTailwindBreakpoin = (0,TailwindBreakpointContext/* useTailwindBreakpoint */._)(),
      screenWidth = _useTailwindBreakpoin.screenWidth;

  var _useState = (0,react.useState)(null),
      maxHeight = _useState[0],
      setMaxHeight = _useState[1];

  var ref = (0,react.useRef)();
  (0,react.useEffect)(function () {
    setMaxHeight(null);
  }, []);
  (0,react.useEffect)(function () {
    setMaxHeight(null);
  }, [subItems, lang, label, screenWidth]);
  (0,react.useEffect)(function () {
    if (!maxHeight) {
      var _ref$current;

      setMaxHeight((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.clientHeight);
    }
  }, [maxHeight]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "relative flex flex-col items-start w-full space-y-[18px]",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      ref: ref,
      className: "w-full flex justify-start items-center space-x-[20px]",
      children: subItems.map(function (item) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: item.linkTo,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            className: "w-1/4 flex border-lightBlue-50 space-x-[16px] border-2 px-[20px] py-[16px] rounded-[6px] hover:bg-lightBlue-50",
            style: {
              height: maxHeight
            },
            children: [(item === null || item === void 0 ? void 0 : item.icon) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "w-[24px] menu-icon",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: item.icon,
                width: 24,
                height: 24,
                layout: "fixed"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex flex-col justify-start",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                className: " text-p2Semibold text-neutral-700",
                children: item.label
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: " text-p3Regular text-neutral-500",
                children: lang === 'en' ? item.subLabel : item.subLabelTH
              })]
            })]
          })
        }, item.label);
      })
    })
  });
};

/* harmony default export */ var Navbar_NavbarDesktopSubItem = (NavbarDesktopSubItem);
;// CONCATENATED MODULE: ./components/Navbar/Navbar.tsx


function Navbar_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Navbar_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Navbar_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Navbar_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




















var Navbar = function Navbar(_ref) {
  var _ref$forOldDesign = _ref.forOldDesign,
      forOldDesign = _ref$forOldDesign === void 0 ? false : _ref$forOldDesign;

  var _useTailwindBreakpoin = (0,TailwindBreakpointContext/* useTailwindBreakpoint */._)(),
      screen = _useTailwindBreakpoin.screen;

  var _useLocale = (0,LocaleContext/* useLocale */.b)(),
      lang = _useLocale.lang,
      setLang = _useLocale.setLang;

  var _useState = (0,react.useState)(false),
      openSidebar = _useState[0],
      setOpenSidebar = _useState[1];

  var _useState2 = (0,react.useState)(defaultItems),
      items = _useState2[0],
      setItems = _useState2[1]; // items for mobile


  var _useState3 = (0,react.useState)(defaultDesktopItems),
      desktopItems = _useState3[0],
      setDesktopItems = _useState3[1]; // items for desktop


  var _useState4 = (0,react.useState)(null),
      desktopExpandItem = _useState4[0],
      setDesktopExpandItem = _useState4[1];

  var SidebarRef = (0,react.useRef)();
  var router = (0,next_router.useRouter)();
  var animateChevron = (0,use_animation/* useAnimation */._)();
  (0,react.useEffect)(function () {
    var _localStorage$getItem;

    var initLang = (_localStorage$getItem = localStorage.getItem('lang')) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : 'th';
    setLang(initLang);
    setActiveItem();
  }, [router]);

  var closeSidebar = function closeSidebar() {
    setOpenSidebar(false);
  };

  var handleClickLogo = function handleClickLogo() {
    closeSidebar();
    modules/* animateScroll.scrollToTop */.NY.scrollToTop();
  };

  var expandSubItem = function expandSubItem(label) {
    setItems(items.map(function (item) {
      var expand = false;

      if (item.label === label) {
        expand = !item.expand;
      }

      return Navbar_objectSpread(Navbar_objectSpread({}, item), {}, {
        expand: expand
      });
    }));
  };

  var expandDesktopSubItem = function expandDesktopSubItem(label) {
    setDesktopItems(desktopItems.map(function (item) {
      var expand = false;

      if (item.label === label) {
        expand = !item.expand;
      }

      return Navbar_objectSpread(Navbar_objectSpread({}, item), {}, {
        active: false,
        // when click expand clear current active route
        expand: expand
      });
    }));
  };

  var setActiveItem = function setActiveItem() {
    var newItems = desktopItems.map(function (item) {
      var _item$subItems;

      var isActive = false;

      if ((item === null || item === void 0 ? void 0 : (_item$subItems = item.subItems) === null || _item$subItems === void 0 ? void 0 : _item$subItems.length) > 0) {
        isActive = item.subItems.filter(function (s) {
          return s.linkTo !== '/';
        }).some(function (s) {
          return s.linkTo === router.pathname;
        });
      } else {
        isActive = item.linkTo === router.pathname;
      }

      return Navbar_objectSpread(Navbar_objectSpread({}, item), {}, {
        expand: false,
        // clear all expand sub items when initial active route
        active: isActive
      });
    });
    setDesktopItems(newItems);
  };

  (0,react.useEffect)(function () {
    var expandItem = null;
    desktopItems.forEach(function (item) {
      if (item !== null && item !== void 0 && item.expand) {
        animateChevron.start({
          rotate: item.expand ? 180 : 0,
          transition: {
            duration: 0.2
          }
        });
        expandItem = item;
      }
    });
    setDesktopExpandItem(expandItem);
  }, [desktopItems]);

  if (screen === 'lg') {
    // DESKTOP
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "fixed top-0 left-0 z-50 w-screen px-6 py-0 flex justify-between items-center bg-white shadow select-none",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            onClick: handleClickLogo,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "flex justify-center items-center w-[140px] h-[52px]",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: "/images/navbar/codiumDarkFull.png",
                width: 140,
                height: 40,
                priority: true
              })
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex space-x-3 items-center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "flex items-center",
            children: desktopItems.map(function (item) {
              var _item$subItems2;

              return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: ((_item$subItems2 = item.subItems) === null || _item$subItems2 === void 0 ? void 0 : _item$subItems2.length) > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(Navbar_NavbarDesktopItem, Navbar_objectSpread(Navbar_objectSpread({}, item), {}, {
                  expandSubItem: expandDesktopSubItem
                })) : /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: item.linkTo,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    onClick: function onClick() {},
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Navbar_NavbarDesktopItem, Navbar_objectSpread({}, item))
                  })
                })
              }, item.label);
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex justify-center items-center text-neutral-700",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              className: "flex items-center cursor-pointer px-2 opacity-50 ".concat(lang === 'th' && 'opacity-100'),
              onClick: function onClick() {
                return setLang('th');
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                className: "text-p3Medium",
                children: "TH"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "w-0.5 h-3.5 bg-neutral-300"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              className: "flex items-center cursor-pointer px-2 opacity-50 ".concat(lang === 'en' && 'opacity-100'),
              onClick: function onClick() {
                return setLang('en');
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                className: "text-p3Medium",
                children: "EN"
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Common/* Button */.z, {
            id: "contact-us",
            text: lang === 'en' ? 'CONTACT US' : 'ติดต่อเรา',
            style: {
              padding: '10px 16px'
            },
            className: "text-p3Medium min-w-[118px]",
            onClick: function onClick() {
              return router.push('/contact-us');
            }
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
        children: desktopExpandItem && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
            className: "fixed top-0 left-0 z-40 w-screen px-[20px] 2xl:px-[89px] pt-[100px] pb-[40px] flex justify-start items-center bg-white shadow select-none rounded-b-[6px]",
            initial: {
              y: '-100%'
            },
            animate: {
              y: 0,
              transition: {
                duration: 0.5
              }
            },
            exit: {
              y: '-100%',
              transition: {
                duration: 0.5
              }
            },
            transition: {
              ease: 'easeInOut'
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Navbar_NavbarDesktopSubItem, Navbar_objectSpread({}, desktopExpandItem))
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
            className: "".concat((Navbar_module_default()).bgBlur, " fixed top-0 left-0 z-30 w-screen h-screen"),
            initial: {
              opacity: 0
            },
            animate: {
              opacity: 1,
              transition: {
                duration: 0.6,
                delay: 0.3
              }
            },
            exit: {
              opacity: 0
            },
            onClick: function onClick() {
              return expandDesktopSubItem(null);
            }
          })]
        })
      }), forOldDesign && /*#__PURE__*/(0,jsx_runtime.jsx)(Navbar_NavbarOldDesignStyle, {})]
    });
  } // MOBILE & TABLET


  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "fixed top-0 left-0 z-40 w-screen px-4 md:px-6 py-2 flex justify-between items-center bg-white shadow select-none",
      children: [screen === 'md' ? /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          onClick: handleClickLogo,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "flex justify-center items-center",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: "/images/navbar/codiumDarkFull.png",
              width: 140,
              height: 40,
              priority: true
            })
          })
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          onClick: handleClickLogo,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "flex justify-center items-center",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: "/images/navbar/codiumDarkFull.png",
              width: 120,
              height: 34,
              priority: true
            })
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex space-x-3 md:space-x-4 items-center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Common/* Button */.z, {
          id: "contact-us",
          text: lang === 'en' ? 'CONTACT US' : 'ติดต่อเรา',
          style: forOldDesign ? {
            padding: '5px 10px'
          } : {
            padding: '0.313rem 0.625rem'
          },
          onClick: function onClick() {
            return router.push('/contact-us');
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: "cursor-pointer",
          onClick: function onClick() {
            return setOpenSidebar(true);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* Hamburger */.pr, {})
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
        children: openSidebar && /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
          ref: SidebarRef,
          className: "absolute top-0 left-0 z-50",
          initial: {
            x: '100vw'
          },
          animate: {
            x: 0
          },
          exit: {
            x: '100vw'
          },
          transition: {
            duration: 0.35
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Sidebar_Sidebar, {
            items: items,
            closeSidebar: closeSidebar,
            clickLogo: handleClickLogo,
            expandSubItem: expandSubItem
          })
        })
      })]
    }), forOldDesign && /*#__PURE__*/(0,jsx_runtime.jsx)(Navbar_NavbarOldDesignStyle, {})]
  });
};

/* harmony default export */ var Navbar_Navbar = (Navbar);
var defaultItems = [{
  icon: '/images/productServices.svg',
  label: 'Product & Services',
  expand: true,
  subItems: [{
    label: 'e-Contract',
    subLabel: 'End-to-end legally binding digital contract.',
    subLabelTH: 'ระบบทำสัญญาดิจิทัล',
    linkTo: '/e-contract',
    icon: '/images/eContract.svg'
  }, {
    label: 'e-Signature',
    subLabel: 'Electronic signature management system.',
    subLabelTH: 'ระบบจัดการลายมือชื่อดิจิทัล',
    linkTo: '/e-signature',
    icon: '/images/eDigitalSignature.svg'
  }, {
    label: 'e-Memo',
    subLabel: 'Digital workflow and approval platform.',
    subLabelTH: 'ระบบจัดการเอกสารออนไลน์',
    linkTo: '/e-memo',
    icon: '/images/eMemo.svg'
  }, {
    label: 'e-Tax Invoice & e-Receipt',
    subLabel: 'All-in-one electronic tax platform.',
    subLabelTH: 'ระบบออกใบกำกับภาษีอิเล็กทรอนิกส์',
    linkTo: '/e-tax',
    icon: '/images/eTax.svg'
  }]
}, {
  icon: '/images/cultureCareer.svg',
  label: 'Culture & Career',
  linkTo: '/culture-career'
}, {
  icon: '/images/newsfeed.svg',
  label: 'Community',
  subItems: [{
    label: 'Blogs',
    subLabel: 'The ultimate enabler is the knowledge in the first place',
    subLabelTH: 'อ่านบทความที่น่าสนใจ',
    linkTo: '/blogs',
    icon: '/images/blogs.svg'
  } // {
  //   label: 'Resources',
  //   subLabel: 'Learning space with educational resources ',
  //   subLabelTH: 'พื้นที่แห่งการเรียนรู้',
  //   linkTo: '/resources',
  //   icon: '/images/resources.svg',
  // },
  ]
}, {
  icon: '/images/contactUs.svg',
  label: 'Contact us',
  linkTo: '/contact-us'
}];
var defaultDesktopItems = [{
  icon: '/images/home.svg',
  inactiveIcon: '/images/homeGray.svg',
  label: 'Home',
  linkTo: '/',
  active: false
}, {
  icon: '/images/productServices.svg',
  inactiveIcon: '/images/productServicesGray.svg',
  label: 'Product & Services',
  expand: false,
  active: false,
  subItems: [{
    label: 'e-Contract',
    subLabel: 'End-to-end legally binding digital contract.',
    subLabelTH: 'ระบบทำสัญญาดิจิทัล',
    linkTo: '/e-contract',
    icon: '/images/eContract.svg'
  }, {
    label: 'e-Signature',
    subLabel: 'Electronic signature management system.',
    subLabelTH: 'ระบบจัดการลายมือชื่อดิจิทัล',
    linkTo: '/e-signature',
    icon: '/images/eDigitalSignature.svg'
  }, {
    label: 'e-Memo',
    subLabel: 'Digital workflow and approval platform.',
    subLabelTH: 'ระบบจัดการเอกสารออนไลน์',
    linkTo: '/e-memo',
    icon: '/images/eMemo.svg'
  }, {
    label: 'e-Tax Invoice & e-Receipt',
    subLabel: 'All-in-one electronic tax platform.',
    subLabelTH: 'ระบบออกใบกำกับภาษีอิเล็กทรอนิกส์',
    linkTo: '/e-tax',
    icon: '/images/eTax.svg'
  }]
}, {
  icon: '/images/cultureCareer.svg',
  inactiveIcon: '/images/cultureCareerGray.svg',
  active: false,
  label: 'Culture & Career',
  linkTo: '/culture-career'
}, {
  icon: '/images/newsfeed.svg',
  inactiveIcon: '/images/newsfeedGray.svg',
  active: false,
  label: 'Community',
  expand: false,
  subItems: [{
    label: 'Blogs',
    subLabel: 'The ultimate enabler is the knowledge in the first place',
    subLabelTH: 'อ่านบทความที่น่าสนใจ',
    linkTo: '/blogs',
    icon: '/images/blogs.svg'
  } // {
  //   label: 'Resources',
  //   subLabel: 'Learning space with educational resources ',
  //   subLabelTH: 'พื้นที่แห่งการเรียนรู้',
  //   linkTo: '/resources',
  //   icon: '/images/resources.svg',
  // },
  ]
}];
;// CONCATENATED MODULE: ./components/Navbar/index.ts


/***/ }),

/***/ 6627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ header; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./models/conent.ts
var conent = __webpack_require__(3290);
// EXTERNAL MODULE: ./components/CookieConsent/index.ts + 5 modules
var CookieConsent = __webpack_require__(5855);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./utils/url.ts
function getPathFromUrl(url) {
  return url.split(/[?#]/)[0];
}
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/_OldDesign/header.tsx











var Header = function Header(props) {
  var _props$content, _props$content2, _props$content3, _props$content4, _props$content5, _props$content6, _props$content7, _props$content8, _props$content9;

  var router = (0,next_router.useRouter)();
  var desc = 'ผู้ให้บริการ Full-service Digital Transformation เปลี่ยนการทำงานจากกระดาษสู่ดิจิทัล ผู้เชี่ยวชาญด้าน Digital Signature ที่กว่า 100 บริษัทที่ไว้วางใจ';
  var image = conent/* webUrl */.wo + '/images/CodiumOgImage.jpg';
  var title = 'CODIUM เปลี่ยนการทำงานจากกระดาษสู่ดิจิทัล';
  var pageUrl = conent/* webUrl */.wo + getPathFromUrl(router.asPath);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "icon",
        type: "image/png",
        href: "/images/CODIUM.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1, maximum-scale=1"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        charSet: "utf-8"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        httpEquiv: "Content-Type",
        content: "text/html; charset=utf-8"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "facebook-domain-verification",
        content: "tnaexja89roj9zcv6qjoz6h5n6naxx"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "google-site-verification",
        content: "Jp479_uwiyZdZ2wLqR4LPesF7e9zfbCdOEWZpzpXvIU"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      noindex: conent/* blockGoogleSearch */.J$,
      title: (_props$content = props.content) !== null && _props$content !== void 0 && _props$content.title ? (_props$content2 = props.content) === null || _props$content2 === void 0 ? void 0 : _props$content2.title : title,
      description: (_props$content3 = props.content) !== null && _props$content3 !== void 0 && _props$content3.content ? (_props$content4 = props.content) === null || _props$content4 === void 0 ? void 0 : _props$content4.content : desc,
      canonical: pageUrl,
      openGraph: {
        type: 'website',
        title: (_props$content5 = props.content) !== null && _props$content5 !== void 0 && _props$content5.title ? (_props$content6 = props.content) === null || _props$content6 === void 0 ? void 0 : _props$content6.title : title,
        description: (_props$content7 = props.content) !== null && _props$content7 !== void 0 && _props$content7.content ? (_props$content8 = props.content) === null || _props$content8 === void 0 ? void 0 : _props$content8.content : desc,
        url: pageUrl,
        site_name: conent/* domain */.nw,
        images: [{
          url: "".concat((_props$content9 = props.content) !== null && _props$content9 !== void 0 && _props$content9.image ? "".concat(props.content.image) : image)
        }]
      },
      twitter: {
        cardType: 'summary_large_image',
        site: '@CodiumOfficial',
        handle: '@CodiumOfficial'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
        id: "smoothscroll.min.js",
        src: "https://unpkg.com/smoothscroll-polyfill/dist/smoothscroll.min.js"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
        id: "smoothscroll-anchor-polyfill",
        src: "https://unpkg.com/smoothscroll-anchor-polyfill"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
        id: "gtm-script",
        dangerouslySetInnerHTML: {
          // Consent Mode defaults run in the same script, ahead of
          // GTM, so no tag can fire before them. A returning
          // visitor's stored choice is applied straight away; it
          // mirrors readConsent() in components/CookieConsent.
          __html: "window.dataLayer=window.dataLayer||[];\n                        function gtag(){dataLayer.push(arguments);}\n                        gtag('consent','default',{analytics_storage:'denied',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied',wait_for_update:500});\n                        try{var m=document.cookie.match(/(?:^|; )".concat(CookieConsent/* CONSENT_COOKIE */.Q8, "=([^;]*)/);\n                        var c=m&&JSON.parse(decodeURIComponent(m[1]));\n                        if(c&&c.v===").concat(CookieConsent/* CONSENT_VERSION */._o, "&&typeof c.analytics==='boolean'&&typeof c.marketing==='boolean'){\n                        var a=c.marketing?'granted':'denied';\n                        gtag('consent','update',{analytics_storage:c.analytics?'granted':'denied',ad_storage:a,ad_user_data:a,ad_personalization:a});}}catch(e){}\n                        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n                        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n                        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n                        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n                        })(window,document,'script','dataLayer','GTM-N3QX6HR');")
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("noscript", {
        dangerouslySetInnerHTML: {
          __html: "<iframe src=\"https://www.googletagmanager.com/ns.html?id=GTM-N3QX6HR\"\n                        height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>"
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
        id: "schema-script",
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            address: {
              "@type": "PostalAddress",
              "addressCountry": "Thailand",
              "addressRegion": "Bangkok",
              "postalCode": "10330",
              "streetAddress": "Rama 1 Road, Wang Mai",
              "address": "Siam@Siam Hotel Building, 7th Floor 865 Rama 1 Road, Wang Mai, Patumwan Bangkok 10330, Thailand"
            },
            name: "Codium",
            telephone: "02 612 3838",
            brand: "E-Memo, E-Digital Signature, E-Tax Invoice, E-Receipt"
          })
        }
      })]
    })]
  });
};

/* harmony default export */ var header = (Header);

/***/ }),

/***/ 3161:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bgBlur":"Navbar_bgBlur__fr22K"};

/***/ })

}]);